import { apiClientes } from "../../config/api";
import { PerguntaTriagemPaVirtual } from "../../interfaces/entities/PerguntaTriagemPaVirtual";
import { BoasVindas } from "../../interfaces/entities/UnimedAcolhe/BoasVindas";
import { ManualAtendimento } from "../../interfaces/entities/UnimedAcolhe/ManualAtendimento";
import { UnimedAcolheMenu } from "../../interfaces/entities/UnimedAcolhe/UnimedAcolheMenu";
import { Response } from "../../interfaces/services/Response";
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";

export const getBoasVindas = async (): Promise<BoasVindas | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetBoasVindas', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getDetalhesManualAtendimento = async (): Promise<ManualAtendimento | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetDetalhesManualAtendimento', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getOQueEOPrograma = async (): Promise<string[] | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetOQueEOPrograma', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response.data.textos;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getPrestadores = async (): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('/SaudeEmocional/GetPrestadores', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return null;
    }
};

export const getTrocaDeProfissionalPsicoterapeuta = async (): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('/SaudeEmocional/getTrocaDeProfissionalPsicoterapeuta', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response ? error.response : error;
    }
};

export const getSolicitacaoTroca = async (): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('/SaudeEmocional/GetSolicitacaoTroca', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return null;
    }
};

export const getConfirmacaoTroca = async (): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('/SaudeEmocional/GetConfirmacaoTroca', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return null;
    }
};

export const salvarRespostaQuestionario = async (respostas: PerguntaTriagemPaVirtual[]): Promise<Response | null> => {
    try {
        const response = await apiClientes.post('/saudeEmocional/salvarRespostaQuestionario', respostas, {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const getMenusSaudeEmocional = async (): Promise<UnimedAcolheMenu[] | null> => {
    try {
        const response = await apiClientes.get('SaudeEmocional/GetMenusSaudeEmocional', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response.data.menu;
    } catch (error) {
        console.log({ error });
        return null;
    }
}